import { PanelLeft } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SidebarIcon = createLucideIcon(PanelLeft);
